const watchScroll = () => {
	const D1Module = document.querySelector('.D1-progress-tracker');
	const A2Module = document.querySelector('.A2-footer');
	const C5Module = document.querySelector('.C5-2-fixed-bottom-bar');

	if (D1Module && A2Module && C5Module) {
		const C5Margin = 30;
		let windowWidth = window.innerWidth;

		const adjustA2MarginTop = () => {
			const C5Rect = C5Module.getBoundingClientRect();
			const C5Height = Math.floor(C5Rect.height + C5Margin);
			A2Module.style.marginTop = `${C5Height}px`;
		};

		const calculate = () => {
			const C5ModuleWrapper = document.querySelector('.C5-2-fixed-bottom-bar__wrapper');
			if (!C5ModuleWrapper) return;

			adjustA2MarginTop();

			const viewportHeight = Math.floor(document.documentElement.clientHeight);

			const D1Rect = D1Module.getBoundingClientRect();
			const A2Rect = A2Module.getBoundingClientRect();
			const C5Rect = C5Module.getBoundingClientRect();

			const D1Height = Math.floor(D1Rect.height);
			const C5Height = Math.floor(C5Rect.height + C5Margin);

			const D1Top = Math.floor(D1Rect.top);
			const A2Top = Math.floor(A2Rect.top);

			const topOffset = D1Height + C5Height;
			const topAnchor = (D1Top + topOffset) - viewportHeight;

			const bottomAbsolute = D1Module.offsetTop + D1Height;
			const bottomAnchor = A2Top - viewportHeight;

			if (topAnchor >= 0) {
				C5Module.classList.add('is-absolute');
				C5Module.classList.remove('is-fixed');
				C5Module.style.top = `${bottomAbsolute}px`;
				C5Module.style.bottom = '';
			} else {
				C5Module.classList.add('is-fixed');
				C5Module.classList.remove('is-absolute');
				C5Module.style.top = '';
				C5Module.style.bottom = '0';

				if (bottomAnchor <= 0) {
					C5Module.classList.remove('is-fixed');
					C5Module.classList.add('is-absolute');
					C5Module.style.bottom = '';
				}
			}
		};

		const onResize = () => {
			const check = window.innerWidth;

			if (check !== windowWidth) {
				windowWidth = check;
				calculate();
			}
		};

		window.addEventListener('scroll', calculate);
		window.addEventListener('resize', onResize);

		calculate();
	}
};

export default watchScroll;
